import React from 'react';

const context = {
  configuration: React.createContext({})
};

export default context;
export { context };
